import { api, API_BASE_URL } from './client';
import { readDownloadResponseBlob } from '@/utils/native-download';
import {
  assertAuthenticationOwner,
  binaryResponseError,
  requireAuthenticationOwner,
} from './binaryRequest';

// Export API
export const exportApi = {
  /**
   * Get export info including available data types and counts
   */
  getInfo: () =>
    api.get<{
      available_types: string[];
      counts: {
        users: number;
        projects: number;
        tasks: number;
        teams: number;
      };
    }>('/export/info'),

  /**
   * Export organization data using server-side generation
   * @param types - Array of data types to export ('users', 'projects', 'tasks', 'teams')
   * @param format - Export format ('json' or 'csv')
   * @returns Blob containing the exported data
   */
  exportData: async (types: string[], format: 'json' | 'csv'): Promise<Blob> => {
    const owner = requireAuthenticationOwner();

    const response = await fetch(`${API_BASE_URL}/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${owner.token}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ types, format }),
    });

    if (!response.ok) {
      throw await binaryResponseError(response, 'Export failed');
    }

    const blob = await readDownloadResponseBlob(response);
    assertAuthenticationOwner(owner);
    return blob;
  },
};
